var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJazzMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Instrument-Saxophone-Play--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Instrument Saxophone Play Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.27 15.68 18.62 4.43a2.12 2.12 0 0 1 1.14 -2.76l0.5 -0.27a0.49 0.49 0 0 0 0.2 -0.68 0.49 0.49 0 0 0 -0.67 -0.2l-0.41 0.23c-2.78 1.15 -6 5.07 -4.71 8.13l0.29 0.69a0.25 0.25 0 0 0 0.32 0.13l0.83 -0.34a0.75 0.75 0 0 1 1 0.41 0.76 0.76 0 0 1 -0.41 1l-0.82 0.34a0.23 0.23 0 0 0 -0.14 0.13 0.21 0.21 0 0 0 0 0.19l0.56 1.37a0.26 0.26 0 0 0 0.33 0.14l1 -0.41a0.75 0.75 0 0 1 1 0.41 0.75 0.75 0 0 1 -0.41 1l-1 0.4a0.25 0.25 0 0 0 -0.13 0.14 0.21 0.21 0 0 0 0 0.19l0.45 1.08a0.81 0.81 0 1 1 -1.49 0.62l-2.9 -6.96a1 1 0 0 0 -1.85 0L8.55 16a1 1 0 0 0 0 0.88 1 1 0 0 0 0.71 0.5 0.79 0.79 0 0 1 0.62 0.48l1.17 2.82C12.16 23.3 15 24 16.7 24c4.86 0 8.02 -4.83 6.57 -8.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37 5.92 9.38 2A2 2 0 0 0 8.55 0.38 2 2 0 0 0 6.79 0.09l-3 0.85a2 2 0 0 0 -1.36 1.9v2.53a2 2 0 1 0 2 2.05s0 -3.51 0 -4.38a0.25 0.25 0 0 1 0.18 -0.24l2.55 -0.71a0.29 0.29 0 0 1 0.22 0 0.26 0.26 0 0 1 0.1 0.2v1.58a2 2 0 1 0 2 2.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38 9a1 1 0 0 0 -1 1v2.25a2 2 0 1 0 2 2s0 -4.3 0 -4.3a1 1 0 0 0 -1 -0.95Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJazzMusic);
export default ForwardRef;